let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aDcXM")).then(() => parcelRequire('jLqzd'));